import { createSlice } from "@reduxjs/toolkit";
import { AppBackdropState } from "./type";

let initialState: AppBackdropState = {
  isBackdropVisible: false,
};

const appBackdrop = createSlice({
  name: "appBackdrop",
  initialState,
  reducers: {
    setAppBackdrop(state, action) {
      state.isBackdropVisible = action.payload;
    },
  },
});

export const { setAppBackdrop } = appBackdrop.actions;

export default appBackdrop.reducer;
